import { BehaviorLabel, GetBehaviorDescription } from 'utils/strings';

import { BEHAVIOR_KEYS, BehaviorKey, LEADER_ONLY_BEHAVIOR } from '../recognition';
import { ChoiceTile, ILLUSTRATED_TILE_CLASSES } from './choice-tile';
import { BEHAVIOR_ART } from './recognition-art';
import { Emphasis, StepHeading, StepPanel } from './step-layout';

interface BehaviorStepProps {
  colleagueName: string;
  /** Só quem lidera pode ser reconhecido por Liderança Integradora. */
  colleagueIsLeader: boolean;
  behavior?: BehaviorKey;
  onSelect: (behavior: BehaviorKey) => void;
}

/** Etapa 2: o comportamento reconhecido (REC-23 a REC-25). */
export function BehaviorStep({ colleagueName, colleagueIsLeader, behavior, onSelect }: BehaviorStepProps) {
  const options = BEHAVIOR_KEYS.filter(key => key !== LEADER_ONLY_BEHAVIOR || colleagueIsLeader);

  return (
    <div className="flex flex-col gap-3.5">
      <StepHeading>
        Por qual comportamento você vai reconhecer <Emphasis>{colleagueName}</Emphasis>?
      </StepHeading>

      <StepPanel>
        <fieldset className="m-0 min-w-0 border-0 p-0">
          <legend className="screen-reader-text">Comportamento</legend>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            {options.map(key => {
              const selected = behavior === key;

              return (
                <ChoiceTile
                  key={key}
                  name="comportamento"
                  value={key}
                  checked={selected}
                  onSelect={() => onSelect(key)}
                  className={`${ILLUSTRATED_TILE_CLASSES} min-h-[108px] flex-col justify-center gap-2 px-2.5 py-3 sm:min-h-[122px] sm:gap-2.5 sm:py-4`}
                >
                  <img src={BEHAVIOR_ART[key]} alt="" className="h-12 w-12 object-contain sm:h-14 sm:w-14" />
                  <span
                    className={`text-center text-xs leading-[1.3] ${selected ? 'font-bold text-brand-blue-dark' : 'font-semibold text-content'}`}
                  >
                    {BehaviorLabel[key]}
                  </span>
                </ChoiceTile>
              );
            })}
          </div>
        </fieldset>

        {/* Região viva: a descrição muda com a escolha e o leitor de tela a ouve sem sair do grupo. */}
        <p aria-live="polite" className="m-0 text-[12.5px] leading-normal text-content [text-wrap:pretty] empty:hidden">
          {behavior ? GetBehaviorDescription(behavior) : null}
        </p>
      </StepPanel>
    </div>
  );
}
